import { render } from "./sales-settlement.vue?vue&type=template&id=673ccb16&scoped=true"
import script from "./sales-settlement.vue?vue&type=script&lang=js"
export * from "./sales-settlement.vue?vue&type=script&lang=js"

import "./sales-settlement.vue?vue&type=style&index=0&id=673ccb16&lang=scss&scoped=true&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ccb16"]])

export default __exports__